import {sendRequest} from "./Sender";

export const PlaningService = {
    GetList,
    GetBirthdays,
    Create,
    Update
}

function GetList(params= {}, expand = ''){
    return sendRequest('planing', 'GET', {...params}, true)
}

function GetBirthdays(params= {}, expand = ''){
    return sendRequest('planing/birthdays', 'GET', {...params}, true)
}

function Create(data){
    return sendRequest('planing', 'POST', {...data}, true)
}


function Update(event_id, data){
    return sendRequest('planing/' + event_id, 'PUT', {...data}, true)
}

